import Index from "@/views/Index.vue";
import Login from "@/views/Login.vue";

//路由列表
const routers=[

    {
        path: '/login',
        name: '登录',
        component: Login
    },

    {
        path: '/',
        name: '首页',
        component: Index
    },

];

export default routers;